export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = "https://cdn-staging.groover.co/"

export const appHead = {"meta":[{"name":"robots","key":"robots","content":"noindex, nofollow"},{"name":"google-site-verification","content":"kFdEo_PfbQZI4AovcULSr-kYEzP-xaqK4YXrSZernrs"},{"name":"keywords","content":"Groover,promotion,promouvoir sa musique,musique,influenceurs,radio,label,booker,média,media,webradio,playlist,playlister,promote,influencer,influencers,track,tune,song,music"},{"name":"description","key":"description","content":"Groover is the best way to promote your music to blogs, radios, labels, playlists. Get your track listened to, feedback guaranteed & more"},{"charset":"UTF-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"property":"og:title","key":"og:title","content":"Groover | Music Promotion With Results"},{"property":"og:image","content":"https://cdn-staging.groover.co/media/groover-home.jpg"},{"property":"og:description","key":"og:description","content":"Groover is the best way to promote your music to blogs, radios, labels, playlists. Get your track listened to, feedback guaranteed & more"},{"property":"og:type","content":"website"},{"name":"msapplication-TileColor","content":"#eb6345"},{"name":"msapplication-config","content":"https://cdn-staging.groover.co/media/browserconfig.xml"},{"name":"theme-color","content":"#ffffff"}],"link":[{"href":"https://cdn-staging.groover.co","rel":"preconnect","crossorigin":"anonymous"},{"rel":"apple-touch-icon","sizes":"180x180","href":"https://cdn-staging.groover.co/media/favicons/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://cdn-staging.groover.co/media/favicons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"https://cdn-staging.groover.co/media/favicons/favicon-16x16.png"},{"rel":"manifest","href":"https://cdn-staging.groover.co/media/favicons/site.webmanifest"},{"rel":"mask-icon","href":"https://cdn-staging.groover.co/media/favicons/safari-pinned-tab.svg","color":"#EB512F"},{"rel":"shortcut icon","href":"https://cdn-staging.groover.co/media/favicons/favicon.ico"}],"style":[],"script":[{"id":"partytown-config","innerHTML":"partytown = { debug: false, forward: [], lib: \"/~partytown/\" }"},{"id":"partytown","innerHTML":"/* Partytown 0.11.0 - MIT QwikDev */\nconst t={preserveBehavior:!1},e=e=>{if(\"string\"==typeof e)return[e,t];const[n,r=t]=e;return[n,{...t,...r}]},n=Object.freeze((t=>{const e=new Set;let n=[];do{Object.getOwnPropertyNames(n).forEach((t=>{\"function\"==typeof n[t]&&e.add(t)}))}while((n=Object.getPrototypeOf(n))!==Object.prototype);return Array.from(e)})());!function(t,r,o,i,a,s,c,l,d,p,u=t,f){function h(){f||(f=1,\"/\"==(c=(s.lib||\"/~partytown/\")+(s.debug?\"debug/\":\"\"))[0]&&(d=r.querySelectorAll('script[type=\"text/partytown\"]'),i!=t?i.dispatchEvent(new CustomEvent(\"pt1\",{detail:t})):(l=setTimeout(v,(null==s?void 0:s.fallbackTimeout)||1e4),r.addEventListener(\"pt0\",w),a?y(1):o.serviceWorker?o.serviceWorker.register(c+(s.swPath||\"partytown-sw.js\"),{scope:c}).then((function(t){t.active?y():t.installing&&t.installing.addEventListener(\"statechange\",(function(t){\"activated\"==t.target.state&&y()}))}),console.error):v())))}function y(e){p=r.createElement(e?\"script\":\"iframe\"),t._pttab=Date.now(),e||(p.style.display=\"block\",p.style.width=\"0\",p.style.height=\"0\",p.style.border=\"0\",p.style.visibility=\"hidden\",p.setAttribute(\"aria-hidden\",!0)),p.src=c+\"partytown-\"+(e?\"atomics.js?v=0.11.0\":\"sandbox-sw.html?\"+t._pttab),r.querySelector(s.sandboxParent||\"body\").appendChild(p)}function v(n,o){for(w(),i==t&&(s.forward||[]).map((function(n){const[r]=e(n);delete t[r.split(\".\")[0]]})),n=0;n<d.length;n++)(o=r.createElement(\"script\")).innerHTML=d[n].innerHTML,o.nonce=s.nonce,r.head.appendChild(o);p&&p.parentNode.removeChild(p)}function w(){clearTimeout(l)}s=t.partytown||{},i==t&&(s.forward||[]).map((function(r){const[o,{preserveBehavior:i}]=e(r);u=t,o.split(\".\").map((function(e,r,o){var a;u=u[o[r]]=r+1<o.length?u[o[r]]||(a=o[r+1],n.includes(a)?[]:{}):(()=>{let e=null;if(i){const{methodOrProperty:n,thisObject:r}=((t,e)=>{let n=t;for(let t=0;t<e.length-1;t+=1)n=n[e[t]];return{thisObject:n,methodOrProperty:e.length>0?n[e[e.length-1]]:void 0}})(t,o);\"function\"==typeof n&&(e=(...t)=>n.apply(r,...t))}return function(){let n;return e&&(n=e(arguments)),(t._ptf=t._ptf||[]).push(o,arguments),n}})()}))})),\"complete\"==r.readyState?h():(t.addEventListener(\"DOMContentLoaded\",h),t.addEventListener(\"load\",h))}(window,document,navigator,top,window.crossOriginIsolated);"}],"noscript":[],"title":"Groover | Music Promotion With Results"}

export const appBaseURL = "/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = "silent"

export const nuxtLinkDefaults = {"trailingSlash":"append","componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true